import type { ComplianceStatus, VendorResource } from '../../../services/vendorService';

/**
 * M14c (HE Part 2) – the vendor page's one compliance banner.
 *
 * Compliance documents warn, they do not stop work (H4): a vendor with a lapsed or missing
 * certificate can still be used. The banner names what to update and says plainly that it is a
 * warning. Vendor ACTIVATION still needs current WCB and liability insurance (M14b) – that rule
 * is unchanged and is shown in the pending-approval banner instead.
 */
export function complianceBannerItems(
  compliance: ComplianceStatus | null | undefined,
  resources: Pick<VendorResource, 'name' | 'isActive' | 'requiresVehicleInsurance' | 'vehicleInsuranceExpDate'>[] = [],
  now: Date = new Date(),
): string[] {
  const items: string[] = [];
  if (compliance?.wcbMissing || compliance?.wcbExpired) items.push('WCB clearance');
  if (compliance?.insuranceMissing || compliance?.insuranceExpired) items.push('liability insurance');
  const lapsedMachines = resources
    .filter((r) => r.isActive && r.requiresVehicleInsurance)
    .filter((r) => !r.vehicleInsuranceExpDate || new Date(r.vehicleInsuranceExpDate) < now)
    .map((r) => r.name);
  if (lapsedMachines.length) items.push(`vehicle insurance (${lapsedMachines.join(', ')})`);
  return items;
}

export function complianceBannerText(items: string[]): string {
  return (
    `Compliance documents missing or expired: ${items.join(', ')}. ` +
    'This is a warning – the vendor can still be used for work. Please update the documents.'
  );
}
